<template>
  <div class="ioc-forms">
    <el-form
      :model="form"
      size="mini"
      ref="form"
      :label-suffix="option.labelSuffix || ''"
      :label-position="option.labelPosition || 'right'"
      :label-width="labelWidth(option)"
    >
      <el-row>
        <template v-for="(col, index) in option.column">
          <el-col
            :key="index"
            v-if="typeof col.display === 'undefined' || col.display"
            :span="col.span || 12"
          >
            <el-form-item
              :prop="col.prop"
              :label="col.label"
              v-if="!col.hide"
              :style="{
                paddingLeft: setPx((option.gutter || 20) / 2),
                paddingRight: setPx((option.gutter || 20) / 2)
              }"
              :key="index"
              :rules="col.rules"
              :label-suffix="col.labelSuffix || ''"
              :label-position="col.labelPosition || 'right'"
              :label-width="labelWidth(col)"
            >
              <template>
                <slot v-if="col.formslot" :name="col.prop" :scope="form"></slot>
                <el-select
                  v-model="form[col.prop]"
                  :disabled="col.disabled"
                  v-else-if="col.type === 'select'"
                  @change="selectChange(col)"
                >
                  <el-option
                    v-for="item in col.dicData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-else-if="col.type === 'datetime'"
                  :disabled="col.disabled"
                  v-model="form[col.prop]"
                ></el-date-picker>
                <el-upload
                  v-else-if="col.type === 'upload'"
                  action
                  :file-list="form[col.prop]"
                  ref="addRosterUl"
                  :show-file-list="col['show-file-list'] || true"
                  :list-type="col['list-type'] || 'picture-card'"
                  accept="image/png, image/jpg, image/jpeg, image/bpm"
                  :auto-upload="col['auto-upload'] || false"
                  :disabled="col.disabled || false"
                  :limit="col.limit || 1"
                  :on-change="onChange"
                  :on-remove="onRemove"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-input
                  v-else
                  :placeholder="col.placeholder"
                  v-model="form[col.prop]"
                  :disabled="col.disabled"
                  :type="col.type || 'text'"
                  :maxlength="col.maxlength"
                  show-word-limit
                  :readonly="col.readonly"
                  :autosize="{
                    minRows: col.minRows || 5,
                    maxRows: col.maxRows || 10
                  }"
                  @change="inputChange(col)"
                ></el-input>
              </template>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "IocForms",
  model: {
    prop: "formData",
    event: "handleReturn"
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      form: {},
      fileColumn: ""
    };
  },
  computed: {},
  watch: {
    formData: {
      deep: true,
      handler(newVal) {
        this.form = newVal;
      },
      immediate: true
    },
    form: {
      deep: true,
      handler(newVal) {
        this.form = newVal;
        if (this.option.column && this.option.column.length) {
          this.option.column.forEach((item) => {
            if (item.value) {
              this.form[item.prop] = item.value;
            }
          });
        }
        this.$emit("handleReturn", this.form);
      },
      immediate: true
    }
  },
  mounted() {
    if (this.option && this.option.column) {
      this.option.column.some((item) => {
        this.fileColumn = item.prop;
        return item.type === "upload";
      });
    }
  },
  methods: {
    selectChange(val) {
      this.$emit(val.prop + "-change", { ...this.form });
    },
    inputChange(val) {
      this.$emit(val.prop + "-change", { ...this.form });
    },
    setPx(val, defval = "") {
      val = val + "";
      if (val.indexOf("%") === -1) {
        val = val + "px";
      }
      return val;
    },
    labelWidth(val) {
      if (typeof val.labelWidth === "number") {
        return val.labelWidth + "px";
      } else if (
        typeof val.labelWidth === "string" &&
        this.option.labelWidth.indexOf("px") === -1
      ) {
        return val.labelWidth + "px";
      } else if (val.labelWidth) {
        return val.labelWidth;
      } else {
        return "100px";
      }
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    clearValidate() {
      this.$refs.form.clearValidate();
    },
    /**
     * 清空表单字段
     * @param part:true 清空在column中字段,否则清空全部
     */
    resetForm() {
      this.clearValidate();
      this.$emit("input", this.form);
      this.$emit("reset-change");
    },
    validate(callback) {
      this.$refs["form"].validate((valid) => callback(valid));
    },
    submit() {
      this.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.form);
        }
      });
    },
    onChange(file, fileList) {
      if (this.fileColumn) {
        if (!this.validImg(file)) {
          this.deleteImg(file, fileList);
          return false;
        }
        this.$set(this.form, this.fileColumn, fileList);
        // this.form[this.fileColumn] = fileList
      }
    },
    deleteImg(file, fileList) {
      if (this.fileColumn) {
        let index = this.form[this.fileColumn].findIndex((item) => {
          return item.url === file.url;
        });
        fileList.splice(index, 1);
      }
    },
    onRemove(file, fileList) {
      if (this.form[this.fileColumn]) {
        // this.form[this.fileColumn] = fileList
        this.$set(this.form, this.fileColumn, fileList);
      }
    }
  }
};
</script>

<style></style>
